import { FC, ReactNode } from 'react';
import { IconButton, Modal, ModalHeader, ModalProps } from '@lambdacurry/component-library';
import { MedusaProductVariant } from 'lib/home/generated/types/api';
import { MealImage, NutritionLabel } from 'lib/components';
import { FavoriteButton } from '../../Buttons';
import './nutrient-label-modal.scss';

export interface NutrientLabelModalProps extends ModalProps {
  actions?: ReactNode;
  meal?: MedusaProductVariant;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onProductVariantUpdate?: (item: MedusaProductVariant) => void;
}

export const NutrientLabelModal: FC<NutrientLabelModalProps> = ({
  actions,
  isOpen,
  meal,
  setIsOpen,
  onProductVariantUpdate,
  ...props
}) => {
  const { dietary_information, product, variant_preference } = meal;
  const { description, thumbnail, title } = product;
  const { never } = variant_preference || {};

  return (
    <Modal className="nutrient-label-modal" isOpen={isOpen} {...props}>
      {meal ? (
        <>
          <div className="flex items-center justify-between mb-4">
            {never && <div className="bg-stone-700 text-white p-2 w-32 text-center absolute left-0 top-4">Never</div>}
            {!never && <FavoriteButton meal={meal} onProductVariantUpdate={onProductVariantUpdate} />}

            <IconButton
              aria-label={`close modal`}
              className="ml-auto"
              data-cy={`close-btn`}
              icon="close"
              onClick={() => setIsOpen(false)}
            />
          </div>

          <ModalHeader title={title} />

          <div className="grid grid-cols-2 gap-x-6">
            <div className="col-span-2 md:col-span-1 mb-4">
              <div className="flex flex-col md:flex-row items-center">
                <MealImage className="max-w-full" url={thumbnail} title={title} />
              </div>

              {dietary_information && (
                <>
                  <h3 className="mt-4">What’s in it?</h3>
                  <p className="my-0 uppercase text-sm md:text-base">{dietary_information.ingredients.join(', ')}</p>
                </>
              )}

              {description && (
                <>
                  <h3 className="mt-4">Description</h3>
                  <p className="my-0 uppercase text-sm md:text-base">{description}</p>
                </>
              )}
            </div>

            <div className="col-span-2 md:col-span-1 mb-4">
              {dietary_information && <NutritionLabel nutrients={dietary_information.nutrients} />}
            </div>
          </div>

          {actions && (
            <div className="nutrient-label-modal__actions mt-4 flex flex-col md:flex-row gap-4">{actions}</div>
          )}
        </>
      ) : (
        `There is no meal...`
      )}
    </Modal>
  );
};
